export function formatMoney(amount: number): string {
    try {
        return amount.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    } catch (err) {
        return "E" + amount;
    }
}
